export const translations = {
  el: {
    // Header
    login: 'Σύνδεση',
    signup: 'Εγγραφή',
    signout: 'Έξοδος',
    back: 'Αρχή',

    // Hero
    tagline: 'Ο 1ος ολοκληρωμένος ψηφιακός AI σύμβουλος καριέρας στην Ευρώπη',
    heroMission: 'Αποστολή μας: να αξιοποιήσουμε τη δύναμη της Τεχνητής Νοημοσύνης για να εκδημοκρατίσουμε τη συμβουλευτική καριέρας και να δώσουμε σε κάθε άνθρωπο — όπου κι αν βρίσκεται — τα εφόδια για να επιλέξει το δικό του μονοπάτι.',
    heroLine1: 'Καλωσόρισες.',
    heroLine2: 'Η πορεία σου',
    heroLine3: 'ξεκινά εδώ.',
    chatPlaceholder: 'Πες μου λίγα λόγια για σένα...',
    startBtn: 'Εκκίνηση →',
    analyzing: 'Ανάλυση...',
    learnMore: 'Μάθε Περισσότερα',

    // Journey section
    journeyTitle: 'Ποια κατηγορία σε εκφράζει;',
    journeyCards: [
      { id: 'highschool',    prompt: 'Είμαι μαθητής και θέλω να δω τι να σπουδάσω',                        type: 'highschool' },
      { id: 'university',   prompt: 'Είμαι φοιτητής και θέλω να δω τις επαγγελματικές μου επιλογές',       type: 'university' },
      { id: 'employee',     prompt: 'Είμαι υπάλληλος και θέλω να αλλάξω καριέρα / δουλειά',               type: 'employee'   },
      { id: 'graduate',     prompt: 'Μόλις αποφοίτησα και ψάχνω την πρώτη μου δουλειά',                   type: 'university' },
      { id: 'freelancer',   prompt: 'Είμαι ελεύθερος επαγγελματίας και ψάχνω νέες κατευθύνσεις',          type: 'employee'   },
      { id: 'career-change',prompt: 'Ψάχνω μια ριζική αλλαγή κατεύθυνσης στη ζωή μου',                   type: 'employee'   },
    ],

    // Testimonials
    testimonials: [
      { text: 'Η e-Pythia με βοήθησε να επιλέξω Πληροφορική αντί για Οικονομικά. Η καλύτερη απόφαση της ζωής μου!', name: 'Νίκος Π.', role: 'Μαθητής, 17 ετών — Αθήνα' },
      { text: 'Ήμουν stuck 2 χρόνια στο δημόσιο. Τώρα έχω σαφές σχέδιο για το επόμενο κεφάλαιό μου.', name: 'Μαρία Σ.', role: 'Δημόσιος υπάλληλος, 34 ετών — Θεσσαλονίκη' },
      { text: 'Σαν να μίλησα με πραγματικό σύμβουλο καριέρας. Εντυπωσιακά εξατομικευμένο.', name: 'Γιώργος Α.', role: 'Φοιτητής, 26 ετών — Πάτρα' },
    ],

    // Step labels
    stepLabels: ['Προφίλ', 'Πακέτο', 'Ερωτήσεις', 'Στοιχεία', 'Αποτελέσματα'],

    // Choose path
    choosePathTitle: 'Διάλεξε τη Διαδρομή σου',
    choosePathStep: 'Βήμα',
    freePlan: 'Δωρεάν',
    premiumPlan: 'Premium',
    comingSoon: 'Σύντομα κοντά σας',
    startFree: 'Ξεκίνα Δωρεάν →',
    freeFeatures: ['Πλήρης AI ανάλυση καριέρας', 'Persona & Radar Chart', 'Action Plan 5 βημάτων', 'Αποθήκευση αποτελεσμάτων'],

    // Sectors
    sectors: [
      { id: 'public',   title: 'Δημόσιος Τομέας',  description: 'Δημόσια υπηρεσία, δημοτική, περιφερειακή διοίκηση, εκπαίδευση, υγεία' },
      { id: 'private',  title: 'Ιδιωτικός Τομέας', description: 'Εταιρείες, startups, ΜΜΕ, επιχειρηματικές δραστηριότητες' },
    ],
    selectSectorTitle: 'Σε ποιο τομέα δραστηριοποιείσαι;',

    // Highschool types
    highschoolTypes: [
      { id: 'epal',    title: 'ΕΠΑΛ',          description: 'Εκπαίδευση με εργαστήρια, πρακτικές δεξιότητες και άμεση εργασιακή δυνατότητα' },
      { id: 'general', title: 'Γενικό Λύκειο', description: 'Θετική/Τεχνολογική/Ανθρωπιστική κατεύθυνση για πανεπιστημιακές σπουδές' },
    ],
    selectHighschoolTitle: 'Ποιο σχολείο παρακολουθείς;',

    // Contact
    contactTitle: 'Σχεδόν Έτοιμο!',
    contactSubtitle: 'Εισήγαγε τα στοιχεία σου για να λάβεις τη δική σου ανάλυση',
    firstNameLabel: 'Όνομα',
    lastNameLabel: 'Επώνυμο',
    emailLabel: 'Email',
    firstNamePlaceholder: 'Εισήγαγε το όνομά σου',
    lastNamePlaceholder: 'Εισήγαγε το επώνυμό σου',
    emailPlaceholder: 'Εισήγαγε το email σου',
    createAnalysisBtn: 'Δημιουργία της Ανάλυσης μου',

    // Results
    loadingTitle: 'Ανάλυση του προφίλ σου...',
    loadingSubtitle: 'Ο AI σύμβουλος δημιουργεί εξατομικευμένη καθοδήγηση',
    careerMapTitle: 'Ο Χάρτης της Καριέρας σου',
    careerMapRoadmapHint: 'Ακολούθησε τα βήματα για να φτάσεις στον στόχο σου',

    // Action plan
    actionPlanTitle: 'Το Σχέδιο Δράσης σου',
    actionPlanSubtitle: 'Τσέκαρε τα βήματα καθώς τα ολοκληρώνεις',
    actionPlanDone: '🎉 Συγχαρητήρια! Ολοκλήρωσες όλα τα βήματα!',
    stepWord: 'Βήμα',
    stepsOf: 'βήματα',

    // Profile CTA
    createProfileTitle: 'Δημιούργησε το Προφίλ σου',
    createProfileDesc: 'Κάνε track τον στόχο σου, παρακολούθησε το σχέδιο δράσης σου, κέρδισε XP και ξεκλείδωσε badges.',
    createProfileBtn: 'Δημιούργησε το Προφίλ μου →',

    // Auth modal
    authLoginTitle: 'Καλωσόρισες πίσω!',
    authSignupTitle: 'Δημιουργία Λογαριασμού',
    authFirstName: 'Όνομα',
    authLastName: 'Επώνυμο',
    authEmail: 'Email',
    authPassword: 'Κωδικός',
    authFirstNamePlaceholder: 'Το όνομά σου',
    authLastNamePlaceholder: 'Το επώνυμό σου',
    authEmailPlaceholder: 'Το email σου',
    authPasswordPlaceholder: 'Κωδικός (min 6 χαρακτήρες)',
    authLoginBtn: 'Σύνδεση →',
    authSignupBtn: 'Δημιουργία Λογαριασμού →',
    authNoAccount: 'Δεν έχεις λογαριασμό;',
    authHaveAccount: 'Έχεις ήδη λογαριασμό;',
    authSignupLink: 'Εγγράψου',
    authLoginLink: 'Συνδέσου',
    authConfirmMsg: '✅ Έλεγξε το email σου για επιβεβαίωση!',
    authPrivacyNote: 'Τα δεδομένα σου προστατεύονται και δεν μοιράζονται σε τρίτους.',

    // Profile dashboard
    dashboardTitle: 'Το dashboard σου',
    dashboardGreeting: 'Γεια σου',
    dashboardMaxLevel: '🏆 Έχεις φτάσει στο μέγιστο level!',
    dashboardStats: ['Αναλύσεις', 'Συνολικά XP', 'Badges', 'Quests ✅'],
    latestProfileLabel: 'Το τελευταίο σου προφίλ',
    skillsMapTitle: 'Χάρτης Δεξιοτήτων',
    questBoardTitle: '🎮 Quest Board',
    questBoardSubtitle: 'Ολοκλήρωσε τα βήματα & κέρδισε XP',
    questsOf: 'quests',
    badgesTitle: 'Badges',
    sessionHistoryTitle: 'Ιστορικό Αναλύσεων',
    sessionLabel: 'Ανάλυση',
    userTypeLabels: { highschool: 'Μαθητής', university: 'Φοιτητής', employee: 'Επαγγελματίας' },

    // Footer
    footerTerms: 'Όροι Χρήσης',
    footerPrivacy: 'Πολιτική Απορρήτου',
    footerCopy: '© 2025 e-Pythia. Με επιφύλαξη παντός δικαιώματος.',

    // Questionnaire
    prevBtn: 'Προηγούμενο',
    nextBtn: 'Επόμενο',
    finishBtn: 'Ολοκλήρωση',
    questionOf: 'από',
    typeAnswer: 'Γράψε τη δική σου απάντηση...',

    // Prompt language instruction
    promptLang: 'el',

    // Badges
    badges: {
      first_quest:   { name: 'Πρώτη Αποστολή', desc: 'Ολοκλήρωσες την πρώτη σου ανάλυση' },
      action_taker:  { name: 'Πρώτη Δράση',    desc: 'Ολοκλήρωσες ένα βήμα δράσης' },
      plan_complete: { name: 'Πλήρες Πλάνο',   desc: 'Ολοκλήρωσες όλα τα βήματα δράσης' },
      rated:         { name: 'Κριτής',          desc: 'Αξιολόγησες τα αποτελέσματά σου' },
      explorer:      { name: 'Εξερευνητής',     desc: 'Ολοκλήρωσες 2 αναλύσεις' },
      veteran:       { name: 'Βετεράνος',       desc: 'Ολοκλήρωσες 3 αναλύσεις' },
    },

    // Errors
    errorGeneric: 'Συγγνώμη, υπήρξε σφάλμα κατά την επεξεργασία του αιτήματός σου.',
    errorRetry: 'Συγγνώμη, υπήρξε σφάλμα. Παρακαλώ δοκίμασε ξανά.',
    notAnswered: 'Δεν δόθηκε',

    // Prompt type labels
    promptTypeLabels: {
      highschool_epal:    'μαθητής ΕΠΑΛ που σχεδιάζει την επαγγελματική του διαδρομή',
      highschool_general: 'μαθητής Γενικού Λυκείου που χρειάζεται καθοδήγηση για τη κατεύθυνση και τις σπουδές',
      university:         'φοιτητής που σχεδιάζει το επόμενο επαγγελματικό βήμα',
      employee_public:    'επαγγελματίας του δημόσιου τομέα που εξερευνά νέες ευκαιρίες ανέλιξης',
      employee_private:   'επαγγελματίας του ιδιωτικού τομέα που εξερευνά νέες ευκαιρίες ανέλιξης',
    },

    // Radar trait labels
    traitLabels: { creativity: 'Δημιουργικότητα', leadership: 'Ηγεσία', analysis: 'Ανάλυση', communication: 'Επικοινωνία', execution: 'Εκτέλεση' },

    // UI strings
    loading: 'Φόρτωση...',
    authWaiting: 'Παρακαλώ περίμενε...',
    newBadge: 'Νέο badge: ',
    yourProfile: 'Το προφίλ σου',
    levelNames: { 1: 'Αρχάριος', 2: 'Εξερευνητής', 3: 'Στρατηγός', 4: 'Μάστερ' },
    leadSavedTitle: 'Ευχαριστούμε!',
    leadSavedMsg: 'Τα δεδομένα σου αποθηκεύτηκαν με επιτυχία',
    downloadPdf: 'Λήψη PDF',
    ratingQuestion: 'Πόσο χρήσιμο ήταν;',
    ratingThanks: 'Ευχαριστούμε!',
    copied: 'Αντιγράφηκε!',
    shareBtn: 'Κοινοποίησε',
    emailSentMsg: 'Στάλθηκε στο',
    emailSendingBtn: 'Αποστολή...',
    emailResultsBtn: 'Στείλε αποτελέσματα στο email μου',
    shareTextPrefix: 'Ανακάλυψα το καριερικό μου προφίλ στην e-Pythia!',
    shareTextPersonaLabel: 'Είμαι: ',
    shareTextSuffix: '\n\nΔοκίμασε κι εσύ: https://epythia.netlify.app',
    coachingTitle: 'Έτοιμος για το Επόμενο Βήμα;',
    coachingDescPre: 'Η αξιολόγηση AI σου δίνει μια ισχυρή βάση, αλλά ',
    coachingDescHighlight: 'το προσωπικό coaching',
    coachingDescPost: ' μπορεί να σε βοηθήσει ακόμα περισσότερο.',
    coachingFeatures: [
      { title: 'Αποσαφηνίσεις την Κατεύθυνσή σου', sub: 'Με κατάλληλη καθοδήγηση' },
      { title: 'Σχέδιο Δράσης', sub: 'Για τους επόμενους 6-12 μήνες' },
      { title: 'Ξεπεράσεις τα Εμπόδια', sub: 'Αντιμετώπισε τις ανησυχίες σου' },
      { title: 'Μεγιστοποιήσεις το Δυναμικό σου', sub: 'Με expert insights' },
    ],
    coachingFreeNote: '✨ Η πρώτη αναγνωριστική συνεδρία είναι ΔΩΡΕΑΝ',
    coachingFreeNoteDesc: 'Θα γνωριστείτε, θα αναλύσουμε το προφίλ σου και θα σχεδιάσουμε το σχέδιό σας μαζί',
    coachingCTA: 'Κλείσε Δωρεάν Συνεδρία',
    retakeBtn: 'Δοκίμασε Διαφορετικές Απαντήσεις',
    exploreBtn: 'Εξερεύνησε Άλλη Διαδρομή',
    questCompleteMsg: '🎉 Όλα τα quests ολοκληρώθηκαν! +50 bonus XP',
    badgeLocked: '🔒 Κλειδωμένο',
    newAnalysis: 'Νέα Ανάλυση',
    homeBtn: 'Αρχική',
    footerSubtitle: 'AI Σύμβουλος Καριέρας',
    footerRights: 'Με επιφύλαξη παντός δικαιώματος.',
    dateLocale: 'el-GR',
    roadmapKeywords: ['επόμεν', 'βήμα', 'next', 'step'],
    skillsKeywords: ['δεξιότ', 'ικανότ', 'skill', 'abilit', 'competenc'],
    statsTitle: 'Αποτελέσματα',
    statsItems: [
      { label: 'Μαθητές που βρήκαν κατεύθυνση', pct: '92%', w: '92%' },
      { label: 'Φοιτητές με σαφές επαγγ. πλάνο', pct: '88%', w: '88%' },
      { label: 'Επαγγελματίες που άλλαξαν καριέρα', pct: '76%', w: '76%' },
    ],
    testimonialsTitle: 'Τι λένε οι χρήστες',
    homeCoachTitle: 'Θέλεις προσωπικό coaching;',
    homeCoachDesc: 'Συνδέσου με εξειδικευμένο σύμβουλο καριέρας που έχει ζήσει το ίδιο path.',
    homeCoachFeatures: ['Πραγματική εμπειρία στον κλάδο σου', 'Πρακτικές και εφαρμόσιμες συμβουλές', 'Η 1η συνεδρία είναι ΔΩΡΕΑΝ'],
    homeCoachCTA: 'Κλείσε Δωρεάν Συνεδρία',
    choosePathSubtitle: 'Επίλεξε το επίπεδο ανάλυσης που σου ταιριάζει. Και οι δύο οδηγούν σε εξατομικευμένο χάρτη καριέρας.',
    choosePathBasicAccess: 'Βασική Πρόσβαση',
    choosePathFreePlanTitle: 'Δωρεάν Πακέτο',
    choosePathFreeItems: [
      { icon: 'checklist', text: 'Ερωτηματολόγιο (~15 ερωτήσεις)' },
      { icon: 'description', text: 'Χάρτης Καριέρας AI (soft edition)' },
      { icon: 'task_alt', text: 'Σχέδιο Δράσης 5 βημάτων' },
    ],
    choosePathPremiumDesc: 'Γνωστικό ερωτηματολόγιο, AI roadmap & premium PDF.',
    scienceTitle: 'Η Επιστήμη της Επιλογής',
    scienceDesc: 'Η πλατφόρμα χρησιμοποιεί προηγμένη σημασιολογική ανάλυση και γνωστική χαρτογράφηση για να κατανοήσει το μοναδικό σου επαγγελματικό αποτύπωμα. Το AI e-Pythia συνθέτει χιλιάδες δεδομένα καριέρας σε μία συνεκτική αφήγηση για το μέλλον σου.',
    scienceStats: [{ val: '98%', label: 'Ακρίβεια Ανάλυσης' }, { val: '<2min', label: 'Χρόνος Αποτελέσματος' }],
    sectorSelectSubtitle: 'Διάλεξε για να λάβεις προσαρμοσμένες ερωτήσεις',
    questionLabel: 'Ερώτηση',
    backHome: 'Πίσω στην Αρχική',
    back2: 'Πίσω',
    aboutTitle: 'Τι είναι το e-Pythia;',
    aboutDesc: 'Ο πρώτος AI Σύμβουλος Καριέρας στην Ελλάδα, σχεδιασμένος για μαθητές, φοιτητές και επαγγελματίες που θέλουν να ανακαλύψουν ή να αλλάξουν κατεύθυνση.',
    aboutCards: [
      { title: 'Για Μαθητές', desc: 'Βρες ποια σχολή ταιριάζει στα ενδιαφέροντά σου και τον τρόπο σκέψης σου.' },
      { title: 'Για Φοιτητές', desc: 'Χάρτης επαγγελματικών επιλογών βασισμένος στο πτυχίο και τις αξίες σου.' },
      { title: 'Για Επαγγελματίες', desc: 'Δομημένο σχέδιο για αλλαγή καριέρας ή εξέλιξη στον κλάδο σου.' },
    ],
    howTitle: 'Πώς λειτουργεί;',
    howSteps: [
      { title: 'Διάλεξε κατηγορία', desc: 'Μαθητής, Φοιτητής, Υπάλληλος, Απόφοιτος, Ελεύθερος Επαγγελματίας ή Αλλαγή Κατεύθυνσης.' },
      { title: 'Απάντησε στις ερωτήσεις', desc: 'Εξατομικευμένες ερωτήσεις που αποκαλύπτουν τα ενδιαφέροντα, τις αξίες και τις δεξιότητές σου.' },
      { title: 'Λάβε το Χάρτη Καριέρας σου', desc: 'Αναλυτικές οδηγίες, σχέδιο δράσης και επαγγελματικό coaching αν το χρειαστείς.' },
    ],
    startNow: 'Ξεκίνα τώρα',

    // Questions
    questions: {
      highschool_epal: [
        { id: 'workshop_interest', label: 'Ποιο εργαστήριο σε ενδιαφέρει περισσότερο;', type: 'select', options: ['Μηχανολογία','Ηλεκτρολογία','Πληροφορική/IT','Τουρισμός/Ξενοδοχείο','Οικοδομικά','Αυτοκινήτων','Κομμωτική/Αισθητικά','Ξυλουργική','Άλλο'] },
        { id: 'practical_learning', label: 'Προτιμάς να μαθαίνεις κάνοντας (χέρια);', type: 'select', options: ['Πολύ προτίμησή μου','Λίγο','Προτιμώ τη θεωρία'] },
        { id: 'manual_skills', label: 'Πόσο δεξιός είσαι στη χρήση εργαλείων/χεριών;', type: 'select', options: ['Πολύ δεξιός','Μέτρια','Δεν με ενδιαφέρει'] },
        { id: 'immediate_work', label: 'Σημαντικό για σένα να εργάσεις αμέσως μετά;', type: 'select', options: ['Πολύ σημαντικό','Ίσως και το πτυχίο','Μπορώ να περιμένω'] },
        { id: 'salary_motivation', label: 'Πόσο σημαντική είναι η ικανότητα να κερδίσεις σύντομα;', type: 'select', options: ['Πολύ σημαντική','Σημαντική','Δεν με απασχολεί'] },
        { id: 'international', label: 'Θα ήθελες να δουλέψεις στο εξωτερικό με τα credentials σου;', type: 'select', options: ['Ναι, απόλυτα','Ίσως','Όχι'] },
        { id: 'business_idea', label: 'Έχεις σκεφτεί να ξεκινήσεις δική σου δραστηριότητα;', type: 'select', options: ['Ναι, έχω ιδέα','Μπορεί κάποτε','Όχι'] },
        { id: 'further_studies', label: 'Θα ήθελες να κάνεις περαιτέρω σπουδές μετά το ΕΠΑΛ;', type: 'select', options: ['Ναι, ΑΕΙ/ΤΕΙ','Μήπως ειδικότητα','Όχι, θέλω να δουλέψω'] },
        { id: 'personality_work', label: 'Πώς θα περιέγραφες τον εαυτό σου στο χώρο εργασίας;', type: 'select', options: ['Ανεξάρτητος','Συνεργατικός','Αρχηγικός','Λεπτομερής'] },
        { id: 'continuous_learning', label: 'Προθυμία να ενημερώνεσαι με νέες τεχνολογίες;', type: 'select', options: ['Πολύ ενδιαφέρον','Ίσως','Δεν με απασχολεί'] },
        { id: 'team_preference', label: 'Προτιμάς μικρές ή μεγάλες ομάδες εργασίας;', type: 'select', options: ['Μικρές και άμεσες','Δε με νοιάζει','Μεγάλες δομημένες'] },
        { id: 'job_satisfaction', label: 'Τι σε κάνει ικανοποιημένο σε μια δουλειά;', type: 'select', options: ['Αποτέλεσμα που φαίνεται','Καλή αμοιβή','Σταθερότητα','Δημιουργικότητα'] },
        { id: 'challenges', label: 'Πώς αντιμετωπίζεις τα προβλήματα;', type: 'select', options: ['Με πρακτική σκέψη','Ζητώ βοήθεια','Αποφεύγω το πρόβλημα'] },
        { id: 'specialization_plan', label: 'Έχεις ήδη σκεφτεί ποια ειδικότητα ΕΠΑΛ σε ενδιαφέρει;', type: 'text', placeholder: 'π.χ. Μηχανολογία, Ηλεκτρολογία, κλπ' },
        { id: 'vision_35', label: 'Πες με δικά σου λόγια πώς φαντάζεσαι τον εαυτό σου στα 35.', type: 'textarea', placeholder: 'Γράψε τη δική σου απάντηση...' },
      ],
      highschool_general: [
        { id: 'subject', label: 'Ποιο μάθημα σου αρέσει περισσότερο;', type: 'select', options: ['Μαθηματικά','Φυσική','Χημεία/Βιολογία','Προγραμματισμός','Μαθήματα Οικονομικών & Διοίκησης','Τέχνη/Γραφιστικά','Ιστορία/Γλώσσες','Κοινωνικά/Ανθρωπιστικά','Φυσική Αγωγή'] },
        { id: 'learning', label: 'Πώς προτιμάς να μαθαίνεις;', type: 'select', options: ['Μέσα από θεωρία','Μέσα από πράξη','Συνδυαστικά'] },
        { id: 'freetime', label: 'Όταν έχεις ελεύθερο χρόνο, τι κάνεις πιο συχνά;', type: 'select', options: ['Παίζω/χακάρω στον υπολογιστή','Ζωγραφίζω/φτιάχνω βίντεο','Διαβάζω/ψάχνω για ιδέες','Κάνω Αθλήματα','Είμαι με κόσμο'] },
        { id: 'success', label: 'Τι σε κάνει να αισθάνεσαι πετυχημένος;', type: 'select', options: ['Όταν τα καταφέρνω στα δύσκολα προβλήματα','Όταν βοηθάω άλλους','Όταν με αναγνωρίζουν','Όταν μαθαίνω κάτι καινούριο'] },
        { id: 'adaptation', label: 'Πόσο εύκολα προσαρμόζεσαι σε νέα πράγματα;', type: 'select', options: ['Πολύ εύκολα','Ανάλογα τη περίσταση','Δύσκολα'] },
        { id: 'technology', label: 'Τι ρόλο έχει η τεχνολογία στη ζωή σου;', type: 'select', options: ['Κεντρικό','Βοηθητικό','Ελάχιστο'] },
        { id: 'environment', label: 'Σε ποιο περιβάλλον νιώθεις πιο άνετα;', type: 'select', options: ['Με σαφείς κανόνες και ρουτίνα','Σε ανοιχτό, δημιουργικό χώρο'] },
        { id: 'people', label: 'Πόσο σε ενδιαφέρει να δουλέψεις με ανθρώπους;', type: 'select', options: ['Πολύ','Λίγο','Ελάχιστα'] },
        { id: 'abroad', label: 'Θα ήθελες να σπουδάσεις στο εξωτερικό;', type: 'select', options: ['Ναι','Ίσως','Όχι'] },
        { id: 'fear', label: 'Τι φοβάσαι περισσότερο για το μέλλον σου;', type: 'select', options: ['Να μην πετύχω','Να μην ξέρω τι θέλω','Να μην έχω λεφτά','Να βαριέμαι'] },
        { id: 'organized', label: 'Πόσο οργανωμένος είσαι στην καθημερινότητα;', type: 'select', options: ['Πολύ','Μέτρια','Καθόλου'] },
        { id: 'public_speaking', label: 'Πώς νιώθεις όταν πρέπει να μιλήσεις μπροστά σε άλλους;', type: 'select', options: ['Μου αρέσει','Δεν με ενοχλεί','Το αποφεύγω'] },
        { id: 'direction', label: 'Ποια κατεύθυνση σε ενδιαφέρει περισσότερο;', type: 'select', options: ['Θετική (Math, Physics, Biology)','Τεχνολογική (Tech/Engineering)','Οικονομική (Business/Economics)','Ανθρωπιστική (Humanities/Social)'] },
        { id: 'motivation', label: 'Τι θα σε έκανε να ξυπνάς με ενθουσιασμό κάθε μέρα;', type: 'select', options: ['Δημιουργία','Αναγνώριση','Εξερεύνηση','Σταθερότητα'] },
        { id: 'future_vision', label: 'Πες με δικά σου λόγια πώς φαντάζεσαι τον εαυτό σου στα 25.', type: 'textarea', placeholder: 'Γράψε τη δική σου απάντηση...' },
      ],
      university: [
        { id: 'subject', label: 'Ποιο είναι το αντικείμενο σπουδών σου;', type: 'text', placeholder: 'π.χ. Πληροφορική, Business, Ιατρικά...' },
        { id: 'stage', label: 'Σε ποιο στάδιο βρίσκεσαι;', type: 'select', options: ['Πρώτα έτη','Μέση πορεία','Τελειόφοιτος/Μεταπτυχιακός'] },
        { id: 'degree_feeling', label: 'Πώς νιώθεις για το πτυχίο σου;', type: 'select', options: ['Ενθουσιασμένος','Ουδέτερος','Δεν με εκφράζει πια'] },
        { id: 'priority', label: 'Ποιο από τα παρακάτω σου φαίνεται πιο σημαντικό;', type: 'select', options: ['Επαγγελματική σταθερότητα','Ευκαιρίες εξέλιξης','Δημιουργικότητα','Ελευθερία'] },
        { id: 'experience', label: 'Έχεις ήδη επαγγελματική εμπειρία;', type: 'select', options: ['Ναι','Όχι'] },
        { id: 'motivation', label: 'Τι σε κινητοποιεί περισσότερο να δουλέψεις;', type: 'select', options: ['Πρόκληση','Αναγνώριση','Επίδραση','Οικονομική άνεση'] },
        { id: 'work_style', label: 'Πώς προτιμάς να δουλεύεις;', type: 'select', options: ['Σε δομημένο αυστηρό περιβάλλον','Σε startup φάση','Ως freelancer'] },
        { id: 'field', label: 'Ποιο πεδίο σε τραβάει περισσότερο τώρα;', type: 'select', options: ['Τεχνολογία/Data','Marketing/Επικοινωνία','Business/Finance','Έρευνα/Research','Πωλήσεις/Εξυπηρέτηση','Δημόσιος τομέας/ΜΚΟ'] },
        { id: 'asset', label: 'Ποιο είναι το βασικό σου asset;', type: 'select', options: ['Αναλυτική σκέψη','Δημιουργικότητα','Οργάνωση','Διαπροσωπική επικοινωνία'] },
        { id: 'presentation', label: 'Πόσο άνετα νιώθεις να παρουσιάζεις ή να δικτυώνεσαι;', type: 'select', options: ['Πολύ','Μέτρια','Ελάχιστα'] },
        { id: 'risk', label: 'Πώς θα περιέγραφες το ρίσκο;', type: 'select', options: ['Ευκαιρία','Άγχος','Εξαρτάται από το πλαίσιο'] },
        { id: 'masters', label: 'Θα σε ενδιέφερε μεταπτυχιακό;', type: 'select', options: ['Ναι, σίγουρα','Ίσως','Όχι τώρα'] },
        { id: 'location', label: 'Σε ενδιαφέρει να μείνεις Ελλάδα ή να πας εξωτερικό;', type: 'select', options: ['Ελλάδα','Εξωτερικό','Δεν έχω αποφασίσει'] },
        { id: 'clarity', label: 'Πόσο ξεκάθαρο έχεις τι θέλεις να κάνεις μετά;', type: 'select', options: ['Πολύ','Κάπως','Καθόλου'] },
        { id: 'opportunity', label: 'Αν είχες ευκαιρία να δοκιμάσεις κάτι για 6 μήνες χωρίς ρίσκο, τι θα ήταν;', type: 'textarea', placeholder: 'Γράψε τη δική σου απάντηση...' },
      ],
      employee_public: [
        { id: 'experience', label: 'Πόσα χρόνια εμπειρίας έχεις στο δημόσιο;', type: 'select', options: ['0-2 χρόνια','3-5 χρόνια','6-10 χρόνια','10+ χρόνια'] },
        { id: 'position', label: 'Ποια είναι η τρέχουσα θέση σου;', type: 'text', placeholder: 'π.χ. Λειτουργός, Μηχανικός, Εκπαιδευτικός...' },
        { id: 'department', label: 'Σε ποιον τομέα του δημόσιου δραστηριοποιείσαι;', type: 'select', options: ['Εκπαίδευση','Υγεία','Τοπική Αυτοδιοίκηση','Κεντρική Διοίκηση','Δικαιοσύνη','Άλλο'] },
        { id: 'satisfaction', label: 'Πόσο ικανοποιημένος είσαι από τη θέση σου;', type: 'select', options: ['Πολύ','Μέτρια','Καθόλου'] },
        { id: 'change_reason', label: 'Τι σε ωθεί να σκεφτείς αλλαγή;', type: 'select', options: ['Γραφειοκρατία & κανονισμοί','Χαμηλές απολαβές','Μικρή εξέλιξη','Νέες προκλήσεις','Δε σε απασχολεί ακόμη'] },
        { id: 'stability_value', label: 'Πόσο σημαντική είναι η σταθερότητα για σένα;', type: 'select', options: ['Πολύ','Αρκετά','Λίγο'] },
        { id: 'work_life_balance', label: 'Πώς βλέπεις την ισορροπία ζωής–δουλειάς;', type: 'select', options: ['Πρωτεύουσα','Ισορροπημένη','Δευτερεύουσα'] },
        { id: 'learning', label: 'Θέλεις να αποκτήσεις νέες δεξιότητες;', type: 'select', options: ['Ναι, σίγουρα','Ίσως','Όχι'] },
        { id: 'move_direction', label: 'Θα σε ενδιέφερε μετακίνηση σε άλλο τμήμα;', type: 'select', options: ['Μέσα στο ίδιο φορέα','Σε άλλο δημόσιο φορέα','Όχι, προτιμώ ιδιωτικό'] },
        { id: 'public_impact', label: 'Πόσο σημαντικό για σένα είναι το κοινωφελές;', type: 'select', options: ['Πολύ σημαντικό','Κάπως σημαντικό','Δεν με απασχολεί'] },
        { id: 'private_consideration', label: 'Έχεις σκεφτεί ποτέ να πας στον ιδιωτικό τομέα;', type: 'select', options: ['Ναι, σοβαρά','Ίσως','Όχι, θέλω δημόσιο'] },
        { id: 'skills_gap', label: 'Τι δεξιότητες σου λείπουν;', type: 'select', options: ['Digital/IT','Leadership','Foreign languages','Project management','Άλλο'] },
        { id: 'future_role', label: 'Τι ρόλο φαντάζεσαι στο μέλλον;', type: 'select', options: ['Ανέλιξη στο δημόσιο','Αλλαγή τομέα','Ίδια δραστηριότητα','Freelancing/Consulting'] },
        { id: 'pension_concerns', label: 'Πόσο σε ανησυχεί η συνταξιοδότηση;', type: 'select', options: ['Πολύ','Μέτρια','Δεν με απασχολεί'] },
        { id: 'ideal_scenario', label: 'Περιέγραψε το ιδανικό "επόμενο κεφάλαιο" σου.', type: 'textarea', placeholder: 'Γράψε τη δική σου απάντηση...' },
      ],
      employee_private: [
        { id: 'experience', label: 'Πόσα χρόνια εμπειρίας έχεις στον ιδιωτικό τομέα;', type: 'select', options: ['0-2 χρόνια','3-5 χρόνια','6-10 χρόνια','10+ χρόνια'] },
        { id: 'industry', label: 'Σε ποιον κλάδο δραστηριοποιείσαι;', type: 'select', options: ['Τεχνολογία/IT','Τραπεζική/Finance','Marketing/Διαφήμιση','Πωλήσεις','Σύμβουλος/Consulting','Κατασκευή','E-commerce','Άλλο'] },
        { id: 'company_size', label: 'Σε ποιου μεγέθους εταιρεία δουλεύεις;', type: 'select', options: ['Startup (0-50)','SME (50-250)','Mid-size (250-1000)','Large corporation (1000+)'] },
        { id: 'satisfaction', label: 'Πόσο ικανοποιημένος είσαι από τη δουλειά σου;', type: 'select', options: ['Πολύ','Μέτρια','Καθόλου'] },
        { id: 'change_reason', label: 'Τι σε ωθεί να σκεφτείς αλλαγή;', type: 'select', options: ['Burnout','Χαμηλές απολαβές','Κακή κουλτούρα','Μικρή εξέλιξη','Νέο ενδιαφέρον','Δε σε απασχολεί'] },
        { id: 'fulfillment', label: 'Ποιο στοιχείο της δουλειάς σε γεμίζει ακόμα;', type: 'select', options: ['Η ομάδα','Η πρόκληση','Η αμοιβή','Η ευθύνη','Κανένα'] },
        { id: 'next_step', label: 'Τι θα ήθελες να κάνεις μετά;', type: 'select', options: ['Ίδια ρόλο αλλά άλλη εταιρεία','Νέα ρόλο στην ίδια εταιρεία','Αλλαγή κλάδου','Freelancer/Self-employed','Δημόσιος τομέας'] },
        { id: 'salary_expectation', label: 'Ποια είναι η προτεραιότητα σου για τον μισθό;', type: 'select', options: ['Αύξηση','Ισορροπία με άλλα','Δεν είναι πρωτεύουσα'] },
        { id: 'work_life_balance', label: 'Πώς αισθάνεσαι για την εργασία από το σπίτι;', type: 'select', options: ['Προτιμώ remote','Hybrid είναι ιδανικό','Προτιμώ γραφείο'] },
        { id: 'skills_to_develop', label: 'Ποιες δεξιότητες θες να αναπτύξεις;', type: 'select', options: ['Leadership','AI/Machine Learning','Data Analytics','Soft skills','Άλλο'] },
        { id: 'risk_appetite', label: 'Πώς νιώθεις με τη στρατηγική του ρίσκου;', type: 'select', options: ['Αγοράζω τις προκλήσεις','Προσεκτικά','Αποφεύγω τον ρίσκο'] },
        { id: 'career_timeline', label: 'Πόσο επείγουσα είναι η αλλαγή;', type: 'select', options: ['Άμεσα','Στους επόμενους 6 μήνες','Στον επόμενο χρόνο','Δεν είμαι σίγουρος'] },
        { id: 'international', label: 'Θα σε ενδιέφερε θέση στο εξωτερικό;', type: 'select', options: ['Ναι, σίγουρα','Ίσως','Όχι'] },
        { id: 'entrepreneurship', label: 'Έχεις ποτέ σκεφτεί να ξεκινήσεις δική σου εταιρεία;', type: 'select', options: ['Ναι, σοβαρά','Ίσως κάποια στιγμή','Όχι'] },
        { id: 'vision', label: 'Ποια είναι η δική σου ιδανική σταδιοδρομία;', type: 'textarea', placeholder: 'Γράψε τη δική σου απάντηση...' },
      ],
    },
  },

  en: {
    // Header
    login: 'Login',
    signup: 'Sign Up',
    signout: 'Logout',
    back: 'Home',

    // Hero
    tagline: "Europe's 1st comprehensive digital AI career advisor",
    heroMission: 'Our mission: use Artificial Intelligence for good and democratize career counseling worldwide.',
    heroLine1: 'Welcome.',
    heroLine2: 'Your journey',
    heroLine3: 'starts here.',
    chatPlaceholder: 'Tell me a little about yourself...',
    startBtn: 'Get Started →',
    analyzing: 'Analyzing...',
    learnMore: 'Learn More',

    // Journey section
    journeyTitle: 'Which category best describes you?',
    journeyCards: [
      { id: 'highschool',    prompt: 'I\'m a high school student figuring out what to study',               type: 'highschool' },
      { id: 'university',   prompt: 'I\'m a university student exploring my career options',               type: 'university' },
      { id: 'employee',     prompt: 'I\'m employed and looking to change career or job',                   type: 'employee'   },
      { id: 'graduate',     prompt: 'I just graduated and I\'m looking for my first job',                  type: 'university' },
      { id: 'freelancer',   prompt: 'I\'m a freelancer looking for new directions',                        type: 'employee'   },
      { id: 'career-change',prompt: 'I\'m seeking a radical change of direction in my life',               type: 'employee'   },
    ],

    // Testimonials
    testimonials: [
      { text: 'e-Pythia helped me choose Computer Science over Economics. Best decision of my life!', name: 'Nick P.', role: 'Student, 17 — Athens' },
      { text: 'I was stuck in the public sector for 2 years. Now I have a clear plan for my next chapter.', name: 'Maria S.', role: 'Civil servant, 34 — Thessaloniki' },
      { text: 'It felt like talking to a real career advisor. Impressively personalized.', name: 'George A.', role: 'University student, 26 — Patras' },
    ],

    // Step labels
    stepLabels: ['Profile', 'Package', 'Questions', 'Details', 'Results'],

    // Choose path
    choosePathTitle: 'Choose Your Path',
    choosePathStep: 'Step',
    freePlan: 'Free',
    premiumPlan: 'Premium',
    comingSoon: 'Coming soon',
    startFree: 'Start Free →',
    freeFeatures: ['Full AI career analysis', 'Persona & Radar Chart', '5-step Action Plan', 'Save your results'],

    // Sectors
    sectors: [
      { id: 'public',  title: 'Public Sector',   description: 'Civil service, local government, education, healthcare' },
      { id: 'private', title: 'Private Sector',  description: 'Companies, startups, SMEs, entrepreneurial activities' },
    ],
    selectSectorTitle: 'Which sector do you work in?',

    // Highschool types
    highschoolTypes: [
      { id: 'epal',    title: 'Vocational (EPAL)', description: 'Hands-on learning with workshops, practical skills and direct employment' },
      { id: 'general', title: 'General High School', description: 'Science/Tech/Humanities track for university studies' },
    ],
    selectHighschoolTitle: 'Which type of school do you attend?',

    // Contact
    contactTitle: 'Almost There!',
    contactSubtitle: 'Enter your details to receive your personalized analysis',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    emailLabel: 'Email',
    firstNamePlaceholder: 'Enter your first name',
    lastNamePlaceholder: 'Enter your last name',
    emailPlaceholder: 'Enter your email',
    createAnalysisBtn: 'Create My Analysis',

    // Results
    loadingTitle: 'Analyzing your profile...',
    loadingSubtitle: 'The AI advisor is generating personalized guidance',
    careerMapTitle: 'Your Career Map',
    careerMapRoadmapHint: 'Follow the steps to reach your goal',

    // Action plan
    actionPlanTitle: 'Your Action Plan',
    actionPlanSubtitle: 'Check off steps as you complete them',
    actionPlanDone: '🎉 Congratulations! You completed all steps!',
    stepWord: 'Step',
    stepsOf: 'steps',

    // Profile CTA
    createProfileTitle: 'Create Your Profile',
    createProfileDesc: 'Track your goal, follow your action plan, earn XP and unlock badges.',
    createProfileBtn: 'Create My Profile →',

    // Auth modal
    authLoginTitle: 'Welcome back!',
    authSignupTitle: 'Create Account',
    authFirstName: 'First Name',
    authLastName: 'Last Name',
    authEmail: 'Email',
    authPassword: 'Password',
    authFirstNamePlaceholder: 'Your first name',
    authLastNamePlaceholder: 'Your last name',
    authEmailPlaceholder: 'Your email',
    authPasswordPlaceholder: 'Password (min 6 characters)',
    authLoginBtn: 'Login →',
    authSignupBtn: 'Create Account →',
    authNoAccount: "Don't have an account?",
    authHaveAccount: 'Already have an account?',
    authSignupLink: 'Sign up',
    authLoginLink: 'Log in',
    authConfirmMsg: '✅ Check your email to confirm your account!',
    authPrivacyNote: 'Your data is protected and never shared with third parties.',

    // Profile dashboard
    dashboardTitle: 'Your Dashboard',
    dashboardGreeting: 'Hello',
    dashboardMaxLevel: '🏆 You\'ve reached the maximum level!',
    dashboardStats: ['Analyses', 'Total XP', 'Badges', 'Quests ✅'],
    latestProfileLabel: 'Your latest profile',
    skillsMapTitle: 'Skills Map',
    questBoardTitle: '🎮 Quest Board',
    questBoardSubtitle: 'Complete steps & earn XP',
    questsOf: 'quests',
    badgesTitle: 'Badges',
    sessionHistoryTitle: 'Analysis History',
    sessionLabel: 'Analysis',
    userTypeLabels: { highschool: 'Student', university: 'University Student', employee: 'Professional' },

    // Footer
    footerTerms: 'Terms of Service',
    footerPrivacy: 'Privacy Policy',
    footerCopy: '© 2025 e-Pythia. All rights reserved.',

    // Questionnaire
    prevBtn: 'Previous',
    nextBtn: 'Next',
    finishBtn: 'Finish',
    questionOf: 'of',
    typeAnswer: 'Write your answer...',

    // Prompt language instruction
    promptLang: 'en',

    // Badges
    badges: {
      first_quest:   { name: 'First Quest',   desc: 'You completed your first analysis' },
      action_taker:  { name: 'Action Taker',  desc: 'You completed an action step' },
      plan_complete: { name: 'Full Plan',      desc: 'You completed all action steps' },
      rated:         { name: 'Critic',         desc: 'You rated your results' },
      explorer:      { name: 'Explorer',       desc: 'You completed 2 analyses' },
      veteran:       { name: 'Veteran',        desc: 'You completed 3 analyses' },
    },

    // Errors
    errorGeneric: 'Sorry, an error occurred while processing your request.',
    errorRetry: 'Sorry, an error occurred. Please try again.',
    notAnswered: 'Not answered',

    // Prompt type labels
    promptTypeLabels: {
      highschool_epal:    'a vocational high school student planning their career path',
      highschool_general: 'a general high school student seeking guidance on direction and studies',
      university:         'a university student planning their next professional step',
      employee_public:    'a public sector professional exploring new advancement opportunities',
      employee_private:   'a private sector professional exploring new advancement opportunities',
    },

    // Radar trait labels
    traitLabels: { creativity: 'Creativity', leadership: 'Leadership', analysis: 'Analysis', communication: 'Communication', execution: 'Execution' },

    // UI strings
    loading: 'Loading...',
    authWaiting: 'Please wait...',
    newBadge: 'New badge: ',
    yourProfile: 'Your profile',
    levelNames: { 1: 'Beginner', 2: 'Explorer', 3: 'Strategist', 4: 'Master' },
    leadSavedTitle: 'Thank you!',
    leadSavedMsg: 'Your data was saved successfully',
    downloadPdf: 'Download PDF',
    ratingQuestion: 'How helpful was this?',
    ratingThanks: 'Thank you!',
    copied: 'Copied!',
    shareBtn: 'Share',
    emailSentMsg: 'Sent to',
    emailSendingBtn: 'Sending...',
    emailResultsBtn: 'Send results to my email',
    shareTextPrefix: 'I discovered my career profile on e-Pythia!',
    shareTextPersonaLabel: "I'm: ",
    shareTextSuffix: '\n\nTry it too: https://epythia.netlify.app',
    coachingTitle: 'Ready for the Next Step?',
    coachingDescPre: 'The AI assessment gives you a strong foundation, but ',
    coachingDescHighlight: 'personal coaching',
    coachingDescPost: ' can help you even further.',
    coachingFeatures: [
      { title: 'Clarify Your Direction', sub: 'With proper guidance' },
      { title: 'Action Plan', sub: 'For the next 6-12 months' },
      { title: 'Overcome Obstacles', sub: 'Address your concerns' },
      { title: 'Maximize Your Potential', sub: 'With expert insights' },
    ],
    coachingFreeNote: '✨ The first discovery session is FREE',
    coachingFreeNoteDesc: "You'll meet, analyze your profile and plan your roadmap together",
    coachingCTA: 'Book Free Session',
    retakeBtn: 'Try Different Answers',
    exploreBtn: 'Explore Another Path',
    questCompleteMsg: '🎉 All quests completed! +50 bonus XP',
    badgeLocked: '🔒 Locked',
    newAnalysis: 'New Analysis',
    homeBtn: 'Home',
    footerSubtitle: 'AI Career Advisor',
    footerRights: 'All rights reserved.',
    dateLocale: 'en-US',
    roadmapKeywords: ['next step', 'next', 'step', 'roadmap', 'action', 'path'],
    skillsKeywords: ['skill', 'abilit', 'competenc', 'develop'],
    statsTitle: 'Results',
    statsItems: [
      { label: 'Students who found direction', pct: '92%', w: '92%' },
      { label: 'Students with clear career plan', pct: '88%', w: '88%' },
      { label: 'Professionals who changed careers', pct: '76%', w: '76%' },
    ],
    testimonialsTitle: 'What users say',
    homeCoachTitle: 'Want personal coaching?',
    homeCoachDesc: 'Connect with a specialized career advisor who has walked the same path.',
    homeCoachFeatures: ['Real experience in your field', 'Practical and actionable advice', '1st session is FREE'],
    homeCoachCTA: 'Book Free Session',
    choosePathSubtitle: 'Choose the level of analysis that suits you. Both lead to a personalized career map.',
    choosePathBasicAccess: 'Basic Access',
    choosePathFreePlanTitle: 'Free Package',
    choosePathFreeItems: [
      { icon: 'checklist', text: 'Questionnaire (~15 questions)' },
      { icon: 'description', text: 'AI Career Map (soft edition)' },
      { icon: 'task_alt', text: '5-step Action Plan' },
    ],
    choosePathPremiumDesc: 'Cognitive questionnaire, AI roadmap & premium PDF.',
    scienceTitle: 'The Science of Choice',
    scienceDesc: 'The platform uses advanced semantic analysis and cognitive mapping to understand your unique professional fingerprint. e-Pythia AI synthesizes thousands of career data points into one coherent narrative for your future.',
    scienceStats: [{ val: '98%', label: 'Analysis Accuracy' }, { val: '<2min', label: 'Time to Results' }],
    sectorSelectSubtitle: 'Choose to receive tailored questions',
    questionLabel: 'Question',
    backHome: 'Back to Home',
    back2: 'Back',
    aboutTitle: 'What is e-Pythia?',
    aboutDesc: "Europe's first AI Career Advisor, designed for students, university students and professionals who want to discover or change their direction.",
    aboutCards: [
      { title: 'For Students', desc: 'Find which school matches your interests and way of thinking.' },
      { title: 'For University Students', desc: 'Career options map based on your degree and values.' },
      { title: 'For Professionals', desc: 'Structured plan for a career change or advancement in your field.' },
    ],
    howTitle: 'How does it work?',
    howSteps: [
      { title: 'Choose a category', desc: 'Student, University Student, Employee, Graduate, Freelancer or Career Change.' },
      { title: 'Answer the questions', desc: 'Personalized questions that reveal your interests, values and skills.' },
      { title: 'Get your Career Map', desc: 'Detailed guidance, action plan and professional coaching if needed.' },
    ],
    startNow: 'Start now',

    // Questions (English)
    questions: {
      highschool_epal: [
        { id: 'workshop_interest', label: 'Which workshop interests you most?', type: 'select', options: ['Mechanical Engineering','Electrical Engineering','IT/Computing','Tourism/Hospitality','Construction','Automotive','Beauty/Aesthetics','Woodworking','Other'] },
        { id: 'practical_learning', label: 'Do you prefer learning by doing (hands-on)?', type: 'select', options: ['Strongly prefer it','Somewhat','I prefer theory'] },
        { id: 'manual_skills', label: 'How skilled are you with tools and hands-on work?', type: 'select', options: ['Very skilled','Moderately','Not interested'] },
        { id: 'immediate_work', label: 'Is it important to start working immediately after graduation?', type: 'select', options: ['Very important','Maybe after a degree','Can wait'] },
        { id: 'salary_motivation', label: 'How important is earning money quickly?', type: 'select', options: ['Very important','Important','Not a concern'] },
        { id: 'international', label: 'Would you like to work abroad with your credentials?', type: 'select', options: ['Yes, absolutely','Maybe','No'] },
        { id: 'business_idea', label: 'Have you thought about starting your own business?', type: 'select', options: ['Yes, I have an idea','Maybe someday','No'] },
        { id: 'further_studies', label: 'Would you like to continue studying after vocational school?', type: 'select', options: ['Yes, university','Maybe a specialization','No, I want to work'] },
        { id: 'personality_work', label: 'How would you describe yourself at work?', type: 'select', options: ['Independent','Collaborative','Leadership-oriented','Detail-oriented'] },
        { id: 'continuous_learning', label: 'Willingness to keep up with new technologies?', type: 'select', options: ['Very interested','Maybe','Not concerned'] },
        { id: 'team_preference', label: 'Do you prefer small or large teams?', type: 'select', options: ['Small and direct',"Don't mind",'Large structured teams'] },
        { id: 'job_satisfaction', label: 'What makes you satisfied at work?', type: 'select', options: ['Visible results','Good pay','Stability','Creativity'] },
        { id: 'challenges', label: 'How do you handle problems?', type: 'select', options: ['With practical thinking','I ask for help','I avoid the problem'] },
        { id: 'specialization_plan', label: 'Have you thought about which vocational specialty interests you?', type: 'text', placeholder: 'e.g. Mechanical, Electrical, etc.' },
        { id: 'vision_35', label: 'In your own words, how do you picture yourself at 35?', type: 'textarea', placeholder: 'Write your answer...' },
      ],
      highschool_general: [
        { id: 'subject', label: 'Which subject do you enjoy most?', type: 'select', options: ['Mathematics','Physics','Chemistry/Biology','Programming','Economics & Business','Art/Design','History/Languages','Social/Humanities','Physical Education'] },
        { id: 'learning', label: 'How do you prefer to learn?', type: 'select', options: ['Through theory','Through practice','A combination'] },
        { id: 'freetime', label: 'When you have free time, what do you do most often?', type: 'select', options: ['Play/hack on computers','Draw/create videos','Read/search for ideas','Do sports','Hang out with people'] },
        { id: 'success', label: 'What makes you feel successful?', type: 'select', options: ['Solving hard problems','Helping others','Being recognized','Learning something new'] },
        { id: 'adaptation', label: 'How easily do you adapt to new things?', type: 'select', options: ['Very easily','Depends on the situation','With difficulty'] },
        { id: 'technology', label: 'What role does technology play in your life?', type: 'select', options: ['Central','Supporting','Minimal'] },
        { id: 'environment', label: 'In which environment do you feel most comfortable?', type: 'select', options: ['With clear rules and routine','In an open, creative space'] },
        { id: 'people', label: 'How interested are you in working with people?', type: 'select', options: ['Very','Somewhat','Minimally'] },
        { id: 'abroad', label: 'Would you like to study abroad?', type: 'select', options: ['Yes','Maybe','No'] },
        { id: 'fear', label: 'What do you fear most about your future?', type: 'select', options: ['Not succeeding','Not knowing what I want','Not having money','Being bored'] },
        { id: 'organized', label: 'How organized are you in daily life?', type: 'select', options: ['Very','Moderately','Not at all'] },
        { id: 'public_speaking', label: 'How do you feel about speaking in front of others?', type: 'select', options: ['I enjoy it',"Doesn't bother me",'I avoid it'] },
        { id: 'direction', label: 'Which track interests you most?', type: 'select', options: ['Science (Math, Physics, Biology)','Technology (Tech/Engineering)','Economics (Business/Economics)','Humanities (Humanities/Social)'] },
        { id: 'motivation', label: 'What would make you wake up excited every day?', type: 'select', options: ['Creating','Recognition','Exploration','Stability'] },
        { id: 'future_vision', label: 'In your own words, how do you picture yourself at 25?', type: 'textarea', placeholder: 'Write your answer...' },
      ],
      university: [
        { id: 'subject', label: 'What is your field of study?', type: 'text', placeholder: 'e.g. Computer Science, Business, Medicine...' },
        { id: 'stage', label: 'What stage are you at?', type: 'select', options: ['Early years','Middle of degree','Final year / Postgraduate'] },
        { id: 'degree_feeling', label: 'How do you feel about your degree?', type: 'select', options: ['Enthusiastic','Neutral','It no longer represents me'] },
        { id: 'priority', label: 'Which of the following seems most important to you?', type: 'select', options: ['Professional stability','Growth opportunities','Creativity','Freedom'] },
        { id: 'experience', label: 'Do you already have professional experience?', type: 'select', options: ['Yes','No'] },
        { id: 'motivation', label: 'What motivates you most to work?', type: 'select', options: ['Challenge','Recognition','Impact','Financial comfort'] },
        { id: 'work_style', label: 'How do you prefer to work?', type: 'select', options: ['In a structured environment','In a startup','As a freelancer'] },
        { id: 'field', label: 'Which field attracts you most right now?', type: 'select', options: ['Technology/Data','Marketing/Communications','Business/Finance','Research','Sales/Service','Public sector/NGO'] },
        { id: 'asset', label: 'What is your main asset?', type: 'select', options: ['Analytical thinking','Creativity','Organization','Interpersonal communication'] },
        { id: 'presentation', label: 'How comfortable are you presenting or networking?', type: 'select', options: ['Very','Moderately','Minimally'] },
        { id: 'risk', label: 'How would you describe risk?', type: 'select', options: ['An opportunity','Stress','Depends on context'] },
        { id: 'masters', label: 'Would you be interested in a masters degree?', type: 'select', options: ['Yes, definitely','Maybe','Not right now'] },
        { id: 'location', label: 'Are you interested in staying in Greece or going abroad?', type: 'select', options: ['Greece','Abroad',"Haven't decided"] },
        { id: 'clarity', label: 'How clear are you on what you want to do next?', type: 'select', options: ['Very clear','Somewhat','Not at all'] },
        { id: 'opportunity', label: 'If you could try something for 6 months risk-free, what would it be?', type: 'textarea', placeholder: 'Write your answer...' },
      ],
      employee_public: [
        { id: 'experience', label: 'How many years of experience do you have in the public sector?', type: 'select', options: ['0-2 years','3-5 years','6-10 years','10+ years'] },
        { id: 'position', label: 'What is your current position?', type: 'text', placeholder: 'e.g. Officer, Engineer, Teacher...' },
        { id: 'department', label: 'Which area of the public sector do you work in?', type: 'select', options: ['Education','Healthcare','Local Government','Central Administration','Justice','Other'] },
        { id: 'satisfaction', label: 'How satisfied are you with your position?', type: 'select', options: ['Very','Moderately','Not at all'] },
        { id: 'change_reason', label: 'What is driving you to consider a change?', type: 'select', options: ['Bureaucracy & regulations','Low pay','Limited growth','New challenges','Not considering it yet'] },
        { id: 'stability_value', label: 'How important is stability to you?', type: 'select', options: ['Very','Quite','Not much'] },
        { id: 'work_life_balance', label: 'How do you view work-life balance?', type: 'select', options: ['Top priority','Balanced','Secondary'] },
        { id: 'learning', label: 'Do you want to acquire new skills?', type: 'select', options: ['Yes, definitely','Maybe','No'] },
        { id: 'move_direction', label: 'Would you be interested in moving to another department?', type: 'select', options: ['Within the same organization','Another public body','No, I prefer private sector'] },
        { id: 'public_impact', label: 'How important is public benefit to you?', type: 'select', options: ['Very important','Somewhat important',"Doesn't concern me"] },
        { id: 'private_consideration', label: 'Have you ever considered moving to the private sector?', type: 'select', options: ['Yes, seriously','Maybe','No, I want public sector'] },
        { id: 'skills_gap', label: 'What skills do you feel you lack?', type: 'select', options: ['Digital/IT','Leadership','Foreign languages','Project management','Other'] },
        { id: 'future_role', label: 'What role do you envision for yourself in the future?', type: 'select', options: ['Advancement in public sector','Change sector','Same activity','Freelancing/Consulting'] },
        { id: 'pension_concerns', label: 'How concerned are you about retirement?', type: 'select', options: ['Very','Moderately',"Doesn't concern me"] },
        { id: 'ideal_scenario', label: 'Describe your ideal next chapter.', type: 'textarea', placeholder: 'Write your answer...' },
      ],
      employee_private: [
        { id: 'experience', label: 'How many years of experience do you have in the private sector?', type: 'select', options: ['0-2 years','3-5 years','6-10 years','10+ years'] },
        { id: 'industry', label: 'Which industry are you in?', type: 'select', options: ['Technology/IT','Banking/Finance','Marketing/Advertising','Sales','Consulting','Construction','E-commerce','Other'] },
        { id: 'company_size', label: 'What size company do you work for?', type: 'select', options: ['Startup (0-50)','SME (50-250)','Mid-size (250-1000)','Large corporation (1000+)'] },
        { id: 'satisfaction', label: 'How satisfied are you with your job?', type: 'select', options: ['Very','Moderately','Not at all'] },
        { id: 'change_reason', label: 'What is driving you to consider a change?', type: 'select', options: ['Burnout','Low pay','Poor culture','Limited growth','New interest','Not considering it'] },
        { id: 'fulfillment', label: 'What aspect of your job still fulfills you?', type: 'select', options: ['The team','The challenge','The pay','The responsibility','Nothing'] },
        { id: 'next_step', label: 'What would you like to do next?', type: 'select', options: ['Same role, different company','New role, same company','Change industry','Freelancer/Self-employed','Public sector'] },
        { id: 'salary_expectation', label: 'What is your salary priority?', type: 'select', options: ['Increase','Balance with other factors','Not a priority'] },
        { id: 'work_life_balance', label: 'How do you feel about working from home?', type: 'select', options: ['Prefer remote','Hybrid is ideal','Prefer office'] },
        { id: 'skills_to_develop', label: 'Which skills do you want to develop?', type: 'select', options: ['Leadership','AI/Machine Learning','Data Analytics','Soft skills','Other'] },
        { id: 'risk_appetite', label: 'How do you feel about taking strategic risks?', type: 'select', options: ['I embrace challenges','Cautiously','I avoid risk'] },
        { id: 'career_timeline', label: 'How urgent is the change?', type: 'select', options: ['Immediately','In the next 6 months','In the next year',"I'm not sure"] },
        { id: 'international', label: 'Would you be interested in a position abroad?', type: 'select', options: ['Yes, definitely','Maybe','No'] },
        { id: 'entrepreneurship', label: 'Have you ever thought about starting your own company?', type: 'select', options: ['Yes, seriously','Maybe someday','No'] },
        { id: 'vision', label: 'What is your ideal career path?', type: 'textarea', placeholder: 'Write your answer...' },
      ],
    },
  },
};
